// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signin-page{\n    min-height: calc(100vh - 69px);\n    padding: 100px 0 120px;\n    display: flex;\n}\n\n.signin-page h6.header.text-center {\n    margin-top: 80px;\n}\n\n.signin-page .form{\n    align-items: center;\n    display: flex;\n    align-content: center;\n    margin: 0 auto;\n}\n\n", ""]);
// Exports
module.exports = exports;
